import React, { memo } from 'react'
import { IFactor } from 'types/carrier'
import { DISPLAY } from 'constants/display'

interface IFactoringAddressProps {
  factor?: IFactor
  dialogMode?: boolean
}

export const FactoringAddress = memo<IFactoringAddressProps>(({ dialogMode, factor }) => (
  <>
    <small className={`${dialogMode ? 'text-default' : ''}`}>Factoring Address</small>
    {factor ? (
      <>
        <div>Address #1: {factor.address}</div>
        <div>{factor.address2 ? `Address #2: ${factor.address2}` : DISPLAY.empty} </div>
        <div>
          {factor.city}, {factor.stateCode} {factor.zipcode}
        </div>
        <div>Phone: {factor.contactPhone || DISPLAY.empty}</div>
        <div>Email: {factor.contactEmail || DISPLAY.empty}</div>
      </>
    ) : (
      <p>{DISPLAY.empty}</p>
    )}
  </>
))
